export default class SearchContactActionPayload {
  search: string
  resourceSearch: string

  constructor (search: string, resourceSearch: string) {
    this.search = search
    this.resourceSearch = resourceSearch
  }
}
